import http from "../api/http";
import { api } from "../api/environment";
import { IIndicators, IReport } from "../types/global";

const getIndicators = (startDate: string, endDate: string) => {
  return http.get<IIndicators>(
    `/services/app${api.REPORT_SERVICE}/GetReport?startDate=${startDate}&endDate=${endDate}`
  );
};

const getDetailReport = (startDate: string, endDate: string) => {
  return http.get<IReport>(
    `/services/app${api.REPORT_SERVICE}/GetDetailReport?startDate=${startDate}&endDate=${endDate}`
  );
};

export const reportService = { getIndicators, getDetailReport };
